import { call, put, takeEvery, select } from "redux-saga/effects";

import { callApi } from "../../api/Api";

import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import { FETCH_PROFILE_REQUIRED_FIELD, setRequiredField } from "./action";

export function* callProfileRequiredFields(action) {
  try {
    const { loginState } = yield select();
    const { userContext } = loginState;
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/optional-properties/persons/${action.payload}`,
    });

    const { data } = stateResponse;
    yield put(setRequiredField(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Required Fields" }));
  }
}

export function* watchRequiredFields() {
  yield takeEvery(FETCH_PROFILE_REQUIRED_FIELD, callProfileRequiredFields);
}
